<template>
  <div class="list" ref="wrapper">
    <div class="scroll">
      <template v-if="list.length">
        <div class="brace"></div>
        <div
          class="item"
          @click="gotoArticle(item.bbsId)"
          v-for="item in list"
          :key="item.id"
        >
          <div class="content">
            <div class="name">{{ item.bbsTitle }}</div>
            <div class="event">
              <div class="read">{{ item.bbsReadNum }} 人阅读</div>
              <div class="like">{{ item.bbsDate.substring(0, 10) }}</div>
            </div>
          </div>
          <div class="picture">
            <img :src="item.bbsImgName" alt="" />
          </div>
        </div>
      </template>
      <div v-else-if="isLoad">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import { getArticleList,getLabelList } from 'api'
BScroll.use(Pullup)
let bs
export default {
  data() {
    return {
      pageNum: 1,
      isLoad: false,
      list: [],
      groupIdParamMap: {},
      labelNameArray:["","备孕","避孕","孕妇生活","产后生活"],
      labelId:''
    }
  },
  props: {
    groupId: {
      type: [String, Number]
    }
  },
  watch: {
    groupId(n, o) {
      if (n !== o) {
        let labelName=this.labelNameArray[n]
        if (labelName&&this.groupIdParamMap[labelName]) {
          this.labelId = this.groupIdParamMap[labelName]
        }else{
          this.labelId = ""
        }
        this.pageNum = 1
        this.list = []
        this.getList()
      }
    }
  },
  methods: {
    gotoArticle(id) {
      let authToken = this.$cookies.get('authToken')
      let VUE_APP_KNOWLEDGE_H5_URL = process.env.VUE_APP_KNOWLEDGE_H5_URL
      let path = VUE_APP_KNOWLEDGE_H5_URL + `?id=${id} & authToken=${authToken}`
      window.location.href = path
    },
    getLabel () {
      let that=this
      let params = {
        parent: 0
      }
      getLabelList(params).then(res => {
        res.forEach(info => {
          that.groupIdParamMap[info.labelName]=info.id
        })
        that.getList()
      })
    },
    getList() {
      let params = {
        type: 'text',
        pageNum: this.pageNum
      }
      if (this.labelId) {
        params.id = this.labelId
      }
      getArticleList(params).then((res) => {
        if (res.data.length >= res.pageRow) {
          bs.finishPullUp()
        }
        this.list = [...this.list, ...res.data]
        setTimeout(() => {
          bs.refresh()
        }, 100)
        if (!this.isLoad) {
          this.isLoad = true
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      bs = new BScroll(this.$refs.wrapper, {
        pullUpLoad: true,
        click: true
      })
      bs.on('pullingUp', () => {
        this.pageNum += 1
        this.getList()
      })
      this.getLabel()
    })
  }
}
</script>

<style lang="less" scoped>
.list {
  height: 100%;
  overflow: hidden;
  padding: 0 15px;
  box-sizing: border-box;
  .brace {
    height: 1px;
  }
  .item {
    margin-top: 16px;
    display: -webkit-box;

    .picture {
      width: 128px;
      height: 72px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      margin-left: 12px;
    }

    .content {
      -webkit-box-flex: 1;
      color: #333333;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      padding: 4px 0 6px;

      .name {
        line-height: 21px;
        color: #333;
        font-size: 15px;
        font-weight: 500;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .event {
        display: flex;
        margin-bottom: 5px;
        color: #999;

        & > div {
          background-size: 16px;
          background-repeat: no-repeat;
          background-position: left center;
          font-size: 12px;
          padding-top: 18px;
          margin-right: 25px;
        }

        .read {
        }
      }
    }
  }
}
</style>
